import {PickupPoint} from "./pickup-point";

export class PplParcelshop extends PickupPoint {

	init() {
		document.addEventListener("ppl-parcelshop-map", (e) => {
			this.callback(e.detail)
		})
	}

	callback(location_data) {

		if (location_data != null && typeof location_data !== "undefined") {
			this.set_address({
				'pickup_point_id': location_data.code,
				'company_name': location_data.name,
				'address_line_1': location_data.street,
				'city': location_data.city,
				'zip': location_data.zipCode,
			})
		}

		this.close_pickup()
	}

	open_pickup() {
		jQuery(document).trigger('open_modal', ['checkout-ppl-parcelshop', '', true])
	}

	close_pickup() {
		jQuery(document).trigger('close_modal')
	}

}
